import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  createCoupon,
  deleteCoupon,
  getCouponById,
  getCouponList,
  updateCoupon,
} from '../../services/CouponService'

interface GetCouponListParams {
  pageNumber: number
  pageSize: number
  filterkey: any
}

interface CouponState {
  CouponList: any
  coupon: any
}

const initialState: CouponState = {
  CouponList: null,
  coupon: null,
}

// Fetch coupon list
export const getCouponListApi = createAsyncThunk(
  'coupon/getCouponList',
  async ({pageNumber, pageSize, filterkey}: GetCouponListParams, {rejectWithValue}) => {
    try {
      const result = await getCouponList(pageNumber, pageSize, filterkey)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Fetch coupon by ID
export const getCouponByIdApi = createAsyncThunk(
  'coupon/getCouponById',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await getCouponById(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Create a new coupon
export const createCouponApi = createAsyncThunk(
  'coupon/createCoupon',
  async (payload: any, {rejectWithValue}) => {
    try {
      const result = await createCoupon(payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Update coupon
export const updateCouponApi = createAsyncThunk(
  'coupon/updateCoupon',
  async ({id, payload}: {id: any; payload: any}, {rejectWithValue}) => {
    try {
      const result = await updateCoupon(id, payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Delete coupon
export const deleteCouponApi = createAsyncThunk(
  'coupon/deleteCoupon',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await deleteCoupon(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

const CouponSlice = createSlice({
  name: 'coupon',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getCouponListApi.fulfilled, (state, action) => {
        state.CouponList = action.payload
      })
      .addCase(getCouponByIdApi.fulfilled, (state, action) => {
        state.coupon = action.payload
      })
      .addCase(createCouponApi.fulfilled, (state, action) => {
        state.coupon = action.payload
      })
      .addCase(updateCouponApi.fulfilled, (state, action) => {
        state.coupon = action.payload
      })
      .addCase(deleteCouponApi.fulfilled, (state, action) => {
        state.coupon = null // Assuming after deletion you want to clear the coupon state
        // Alternatively, you could modify the CouponList if necessary.
      })
  },
})

export default CouponSlice
